















import { Component, Vue } from "vue-property-decorator";
import { Assets, Constants, Console, Events, Language } from "@/common/global.ts";

import Store from "@/store.ts";
import BaseView from "@/common/base-view.ts";

@Component
export default class Preloader extends BaseView {

    /**
     * [preloader description]
     *
     * @type {[type]}
     */
    private preloader: any;

    /**
     * [loaded description]
     *
     * @type {[type]}
     */
    private loaded: boolean = false;

    /**
     * created
     */
    public created(): void {
        this.preloader = new window.createjs.LoadQueue();
        window.preloader = this.preloader;
    }

    /**
     * [attachEvents description]
     */
    public attachEvents() {
        this.preloader.addEventListener(Events.COMPLETE, this.Handle_OnComplete);
        this.preloader.addEventListener(Events.PROGRESS, this.Handle_OnProgress);
    }

    /**
     * [detachEvents description]
     */
    public detachEvents() {
        this.preloader.removeEventListener(Events.COMPLETE, this.Handle_OnComplete);
        this.preloader.removeEventListener(Events.PROGRESS, this.Handle_OnProgress);
    }

    /**
     * mounted
     */
    public mounted(): void {
        super.mounted();

        if (Constants.ALLOW_LOADING) {
            setTimeout(() => {
                this.preloader.loadManifest(Assets.FOR_PRELOADER);
            }, Constants.DEMO_MODE ? 2500 : 1);
        }
    }

    /**
     * Set caption under progress bar
     *
     * @type {void}
     */
    public setCaption(caption: string = ""): void {
        const $el: HTMLElement = <HTMLElement> this.$refs.status;

        $el.innerHTML = caption;
    }

    /**
     * Set percentage of fill based on normalized number
     *
     * @type {void}
     */
    public setPercent(normalizedRatio: number = 0): void {
        const $el: HTMLElement = <HTMLElement> this.$refs.fill;
        const percent: number = normalizedRatio * 100;
        const percentAttr: string = percent + "%";

        $el.style.width = percentAttr;
    }


    // Animation
    // ----------------------------------------------------------------

    public AnimateIn(): void {
        const barContainer: HTMLDivElement = <HTMLDivElement> this.$refs.barContainer;
        const caption: HTMLDivElement = <HTMLDivElement> this.$refs.caption;

        barContainer.classList.add("animate-in");
        caption.classList.add("animate-in");
    }


    // Event Handlers
    // ----------------------------------------------------------------

    /**
     * All files have been loaded
     */
    private Handle_OnComplete(): void {
        this.log("Preloader Complete.");

        // Save
        // mk: The delay here is so the slider bar can completely fill
        // out before we show the "COMPLETE" phrase"
        setTimeout(() => {
            this.loaded = Store.state.hasLoaded = true;
        }, 1000);

        // Trigger events
        setTimeout(() => {
            if (Store.state.redirectUrl === "") {
                this.trigger(Events.COMPLETE);
            }
            else {
                this.$router.push(Store.state.redirectUrl);
            }
        }, Constants.DEMO_MODE ? 2500 : 1);
    }

    /**
     * Executed for every file loaded
     */
    private Handle_OnProgress(e: IProgressEvent): void {
        this.setPercent(e.progress);
    }

}
